'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Check = function (_React$PureComponent) {
  _inherits(Check, _React$PureComponent);

  function Check() {
    _classCallCheck(this, Check);

    return _possibleConstructorReturn(this, (Check.__proto__ || Object.getPrototypeOf(Check)).apply(this, arguments));
  }

  _createClass(Check, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color;

      return _react2.default.createElement(
        'svg',
        {
          width: size,
          height: size,
          viewBox: '0 0 27 22',
          xmlns: 'http://www.w3.org/2000/svg'
        },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(-2.000000, -4.000000)', fill: color },
            _react2.default.createElement('path', { d: 'M8.72988242,22.4477979 L11.0787608,24.8964162 C11.4022056,25.2313687 11.7881087,25.4 12.2498541,25.4 C12.7093687,25.4 13.1041945,25.2313687 13.4254086,24.8964162 L15.7720564,22.4477979 L28.2681788,9.40775043 C28.5916236,9.07279793 28.75,8.66854491 28.75,8.18806131 C28.75,7.7052677 28.5916236,7.29639465 28.2681788,6.95913212 L25.9193004,4.50589378 C25.6003169,4.16863126 25.2054912,4 24.7459765,4 C24.2820005,4 23.8983281,4.16863126 23.5748833,4.50589378 L12.2498541,16.3378022 L7.17511674,11.0293826 C6.85167195,10.69212 6.46130754,10.5234888 5.99733155,10.5234888 C5.53781688,10.5234888 5.14968312,10.69212 4.83069963,11.0293826 L2.48182121,13.4780009 C2.15837642,13.8129534 2,14.2218264 2,14.70462 C2,15.1874136 2.15837642,15.5893566 2.48182121,15.9266192 L8.72988242,22.4477979 Z' })
          )
        )
      );
    }
  }]);

  return Check;
}(_react2.default.PureComponent);

Check.defaultProps = {
  color: '#FFFFFF',
  size: 25
};

Check.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = Check;